export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserAccount.vue?vue&type=template&id=d0002e3c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"


//////////////////
// WEBPACK FOOTER
// ./src/components/UserAccount.vue?vue&type=template&id=d0002e3c&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&
// module id = null
// module chunks = 